export default {
    PauseCode: {
        getdata: []
    }
};